export const CONNECTION_STATUS = 'CONNECTION_STATUS';

function pushUpdatedConnectionStatus(isOnline, connectionInfo, retries) {
  return {
    type: CONNECTION_STATUS,
    isOnline,
    connectionInfo,
    retries
  };
}

export function updateConnectionStatus(isOnline, retries) {
  return (dispatch) => {
    const { navigator } = window;
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if (typeof connection === 'undefined' || typeof connection.rtt === 'undefined') {
      return dispatch(pushUpdatedConnectionStatus(isOnline, null, retries));
    }

    return dispatch(pushUpdatedConnectionStatus(isOnline, connection, retries));
  };
}
